import React, { useState } from "react";
import { LinearProgress } from "@mui/material";
import { Mandatory } from "../../FormHelpers";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbarV2 } from "../../../../../state/actions/notification";
import { BotApiServices } from "../../../../../services/api/BotApiServices";
import { ButtonContainer, ButtonProgress, ErrorText, FormContainer, InfoText } from "./Styled";
import { ImagePath } from "../../../../../assets/ImagePath";

import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import config from "../../../../../utils/config/config";
import CachedImage from "../../../../common/CachedImage";


const FileUploadField = (props) => {
	const {
		id,
		title,
		value,
		fileName,
		handleClick,
		info,
		islabelvisible,
		isFileUploading,
		validationResult,
		validationMessage,
		readOnly,
		fileScope,
		addManuallyRow
	} = props;

	const isBoolean = (val) => "boolean" === typeof val;
	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch();

	const selectedConversation = useSelector((state) => state.chats.selectedConversation);
	const user = useSelector((state) => state.user);

	const { conversationId, bot, userDomain } = selectedConversation || {};
	const botId = bot?.botId || '';

	const [scopeId, setScopeId] = useState(() => {
		switch (fileScope) {
			case "bot": {
				return botId;
			}

			case "domain": {
				return userDomain;
			}

			case "conversation":
			default: {
				return conversationId;
			}
		}
	});


	const downloadFile = async () => {
		setIsLoading(true);
		if (user.isOnline) {
			const url = `${config.filesAPI}/downloadwithsignedurl/${fileScope || "conversation"}/${scopeId}/${value}`;
			console.log("Download file url:", url);

			try {
				const response = await BotApiServices.downloadSignedUrlFile(url);

				if (response?.status === 200 && response?.data?.signedUrl) {
					const signedUrl = response.data.signedUrl;

					try {
						const fileResponse = await BotApiServices.downloadFile(signedUrl);

						if (
							fileResponse?.status === 200 &&
							fileResponse?.data instanceof Blob
						) {
							const blob = fileResponse.data;
							const downloadUrl = window.URL.createObjectURL(blob);

							const a = document.createElement("a");
							a.href = downloadUrl;

							// Default to fallback name if not available
							a.download = fileName || "downloaded-file";

							document.body.appendChild(a);
							a.click();
							a.remove();

							// Cleanup
							window.URL.revokeObjectURL(downloadUrl);
						} else {
							throw new Error("Invalid blob response");
						}
					} catch (downloadError) {
						console.error("Download file error:", downloadError);
						dispatch(showSnackbarV2("error", "Failed to download file"));
					}
				} else {
					console.error("Signed URL not received:", response);
					dispatch(showSnackbarV2("error", "Failed to generate signed URL"));
				}
			} catch (signedUrlError) {
				console.error("Error generating signed URL:", signedUrlError);
				dispatch(showSnackbarV2("error", "Failed to generate signed URL"));
			}
			setIsLoading(false);
		} else {
			dispatch(
				showSnackbarV2(
					"error",
					"You will be able to download this file once you are back online"
				)
			);
			setIsLoading(false);
		}
	};


	return (
		<>
			{!value && !readOnly && (
				<div className="relative flex items-center gap-1">

					<div className="w-full ">
						<div className="flex items-center gap-1 mb-[5px]">
							{!islabelvisible && !addManuallyRow  && <span className="min-w-[17px] min-h-[17px] rounded-7 flex items-center justify-center">
								<CachedImage
									image={ImagePath.fileAttachmentField}
									imgKey="file-attachment"
									className="w-[17px] h-[17px]"
								/>
							</span>}
							{!islabelvisible && !addManuallyRow  && <label className="text-size-14 text-[#15194B] font-regular mt-[2px]">
								{<>{title}<Mandatory  {...props} /></>}
							</label>}
						</div>
						<FormContainer>
							<ButtonContainer
								aria-label="upload picture"
								component="label"
								startIcon={<FileUploadOutlinedIcon color="#638dff" />}
								style={{ cursor: 'pointer' }}
							>
								<div className="relative cursor-pointer">
									{/* {title} */}
									<input type="text" placeholder="Select file to attach" className="w-fill-available pl-4 py-2 border border-[#c4d8ffde] rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 bg-blue-50 text-size-14 text-[#000000] placeholder-[#44485A80] h-[40px]" />
									<svg width="23" height="23" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute top-1/2 right-2 transform -translate-y-1/2">
										<path d="M9.31252 23.9683C7.86799 23.9767 6.45352 23.5558 5.24855 22.7591C4.04357 21.9624 3.1024 20.8257 2.54443 19.4932C1.98645 18.1608 1.83682 16.6926 2.11452 15.275C2.39221 13.8574 3.08472 12.5542 4.10419 11.5308L13 2.68704C13.9767 1.71063 15.3013 1.16211 16.6823 1.16211C18.0634 1.16211 19.3879 1.71063 20.3646 2.68704C21.341 3.66375 21.8895 4.98827 21.8895 6.36933C21.8895 7.75039 21.341 9.07492 20.3646 10.0516L11.9584 18.4579C11.6723 18.7649 11.3273 19.0112 10.9439 19.182C10.5606 19.3528 10.1468 19.4446 9.7272 19.452C9.3076 19.4594 8.89082 19.3822 8.5017 19.225C8.11258 19.0679 7.75911 18.8339 7.46236 18.5372C7.16562 18.2405 6.93168 17.887 6.77451 17.4979C6.61734 17.1087 6.54015 16.692 6.54756 16.2724C6.55496 15.8528 6.6468 15.439 6.8176 15.0556C6.9884 14.6723 7.23466 14.3273 7.54169 14.0412L13.3125 8.25995L14.7917 9.73912L9.01044 15.51C8.81429 15.7061 8.70409 15.9721 8.70409 16.2495C8.70409 16.5269 8.81429 16.793 9.01044 16.9891C9.20659 17.1853 9.47262 17.2955 9.75002 17.2955C10.0274 17.2955 10.2935 17.1853 10.4896 16.9891L18.8959 8.58287C19.4829 7.9958 19.8127 7.19957 19.8127 6.36933C19.8127 5.53909 19.4829 4.74286 18.8959 4.15579C18.3088 3.56872 17.5126 3.23891 16.6823 3.23891C15.8521 3.23891 15.0558 3.56872 14.4688 4.15579L5.63544 12.9995C4.6867 13.9818 4.16173 15.2975 4.17359 16.6631C4.18546 18.0287 4.73322 19.335 5.69888 20.3007C6.66455 21.2663 7.97087 21.8141 9.33647 21.826C10.7021 21.8378 12.0177 21.3129 13 20.3641L18.7188 14.6558L20.1875 16.1245L14.4688 21.8433C13.0995 23.2069 11.245 23.9712 9.31252 23.9683Z" fill="black" />
									</svg>
									{!value && (
										<input
											className="absolute inset-0 opacity-0 cursor-pointer"
											id={id}
											name={id}
											accept="*"
											onChange={(e) =>
												handleClick(e, "uploadFile", id, "", scopeId, fileScope)
											}
											type="file"
										/>
									)}
								</div>
							</ButtonContainer>
						</FormContainer>
					</div>
				</div>
			)}

			{isFileUploading?.includes(id) && <LinearProgress />}

			{value && (
				<div className="relative flex items-start gap-1 update-input">

					<div className="w-full">
						<div className="flex items-center gap-1 mb-[5px]">
							{!islabelvisible && !addManuallyRow && <span className="min-w-[17px] min-h-[17px] rounded-7 flex items-center justify-center">
								<CachedImage
									image={ImagePath.fileAttachmentField}
									imgKey="file-attachment"
									className="w-[17px] h-[17px]"
								/>
							</span>}
							{!islabelvisible && !addManuallyRow && <label className="text-size-14 text-[#15194B] font-regular mt-[2px]">
								{<>{title}<Mandatory  {...props} /></>}
							</label>}
						</div>
						<div className="flex items-center gap-1">
							<a className="text-size-14 text-[#0A58DD] underline cursor-pointer" onClick={downloadFile}>
								{fileName || value}
							</a>
							{value && !readOnly && !isLoading && (
								<IconButton
									className="close-icon"
									id={id}
									name={id}
									onClick={(e) => handleClick(e, "removeUploadFile", id, fileScope)}
								>
									<CloseIcon color="#0A58DD" />
								</IconButton>
							)}
							{isLoading && <ButtonProgress size={24} />}
						</div>
					</div>
				</div>
			)}

			{isBoolean(validationResult) && !validationResult ? (
				<ErrorText className="!text-size-14">{validationMessage}</ErrorText>
			) : (
				<InfoText className="!text-size-14">{info}</InfoText>
			)}
		</>
	);
};

export default FileUploadField;
